// Paths that don't require authentication
export const PUBLIC_PATHS = ["/p/auth/login", "/p/auth/join", "/p/auth/password-reset"];

export const CONSTANTS = {
  IMPORT_EXPORT: {
    STATUS_ID: {
      PENDING: "fa5997ef-ba6d-4476-8896-6bf85d0dbe3b",
      SUCCESS: "c2030028-b21d-4683-a97f-63e1d2c82a6d",
      RUNNING: "a1c05ff9-8ee6-47d2-80b2-ef94ae4eb0de",
      CANCELLED: "c1003924-ffc2-47de-be0d-e75a9b810178",
    },
  },
  ENTITY_UIDS: {
    PYLO_USER: "1a6883ee-670e-46f9-bbb3-a3a9844a52b3",
    PYLO_USER_ARO: "fe601d15-0843-4a54-8053-6b7a91230895",
    PYLO_ROOT_ACO: "0c3ed9fc-51eb-45c7-87ab-7b63f0ae4933",
    ENTITY: "6cd03198-b9f2-4047-a59b-d77450fc7ae2",
    PYLO_WEBHOOK: "90acec89-3080-4144-b746-1bb7f90b1fd0",
    PYLO_WEBHOOK_INSTANCE: "90acec89-3080-4144-b746-1bb7f90a1fd2",
    PYLO_FLOW_NODE: "f5a55256-8d03-4d11-a29d-6ac35b8c9a0f",
    PYLO_ARO: "1af73600-35ca-4ccb-991f-2a012956f6a6",
  },
  FLOW_ACTION: {
    SEND_EMAIL: {
      ID: "b67d271b-cbd1-44de-9ff7-82dbe861422d",
      INPUT_PARAMETERS: {
        smtpHost: "de6c6987-7b34-41f6-8f30-de30545ff4eb",
        smtpUser: "c1cd3b13-da2d-42e4-baee-9fad10d154b3",
        smtpPassword: "b1704bb3-bfa1-4c3c-9380-6b7fc607d824",
        from: "8d5ac1bd-5d62-4464-9b02-8e19af202c64",
        to: "595455eb-7349-464a-a596-ca83a1e93e86",
        subject: "52af4c00-e79e-498f-8680-137115527398",
        smtpPort: "1bad98f2-ae3a-4d95-a92f-a9afc902c2d0",
        text: "16010eac-75c2-4406-a17b-78069730df59",
        cc: "d9481f6d-3ef7-41da-8b3a-9648a75066ef",
        bcc: "65028b3d-1af8-4d17-b09b-1bcb933ddde8",
        attachmentMediaIds: "3a3d15a9-9598-4d8d-9677-b4716f8b62bd",
      },
    },
    GENERATE_DOCUMENT: {
      ID: "4767b322-f44f-44d2-80da-dc46ad1a6093",
      INPUT_PARAMETERS: {
        templateKey: "3eeb41d4-e4f1-4ba6-9e4f-1714fb457350",
        variables: "803b937e-b25a-4df6-bf09-1fb2837dc199",
        fileName: "30f38b43-d462-47b0-a699-ac44f87f9241",
      },
    },
  },
};

export const PYLO_CUSTOMER = {
  name: "pylo",
  companyName: "Okeano",
  appName: "Pylo",
  hosts: ["app.pyloapp.com", "localhost:3000"],
  logo: "/images/pylo_logo.png",
  colors: {
    secondary: "#34d399",
    accent: "#dcfce7",
  },
};

export const SUBDOMAINS = [
  PYLO_CUSTOMER,
  {
    name: "okeano",
    companyName: "Okeano",
    appName: "Okeano",
    hosts: [],
    logo: "",
    colors: {
      secondary: "#34d399",
      accent: "#dcfce7",
    },
  },
  {
    name: "ounda",
    companyName: "Ounda",
    appName: "Ounda Database",
    hosts: ["pylo.okeano.de", "ounda.pyloapp.com"],
    logo: "/images/logos/ounda_logo.png",
    colors: {
      secondary: "#05405C",
      accent: "#D6E6EE",
    },
  },
];
